<template>
	<div class="overlay-wrap">
		<div class="">
			<div class="box form-box">
				
			<div class="overlay-form">
				<div class="form-row">
					<span class="box-title">{{ isMondiaUser || isOrangeFrUser ? $t('mondia_email_popup_title') : $t('email_overlay_title') }}</span>
					<img src="../assets/logo/close.svg" alt="close" class="close-btn" v-if="!isMondiaUser && !isOrangeFrUser"  @click="toggleModalDisplay(false)"/>
				</div>
				
				<span class="box-subtitle">{{ isMondiaUser || isOrangeFrUser ? $t('mondia_email_popup_subtitle') : $t('email_overlay_lead2') }}</span>

				<form class="form" @submit.prevent="onSubmit">
					<TextInputField 
						:modelValue="email"
						@update:modelValue="email = $event"
						:field-type="'text'"
						name="email"
						:placeholder="$t('email_overlay_field_placeholder')" 
						:has-error="$v.email.$dirty ? emailErrors[0] : ''"
						:is-required-value="true"
					/>
          			<SubmitButton 
						:label="$t('email_overlay_btn')" 
						:isLoading="isLoading" 
						type="submit"
						class="submit-btn-padding" 
						:isDisabled="false"/>
				</form>
				 
			</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { validationMixin } from 'vuelidate';
	import { required, email } from 'vuelidate/lib/validators';
	import AuthService from '@/services/auth.service';
	import { getErrorString } from '../utils/constant';
	import TextInputField from '../components/TextInputField.vue';
	import SubmitButton from '../components/SubmitButton.vue';

	export default {
		mixins: [validationMixin],
		validations: {
		email: {
			required,
					email,
		}
	},
	components: {
			"TextInputField": TextInputField,
			"SubmitButton": SubmitButton
		},
		data() {
			return {
				email: '',
				isSubmitted: false,
				isLoading: false
			}
		},
		computed: {
			isDisabled() {
				return this.email === '' && !this.isSubmitted;
			},
			emailErrors() {
				const errors = [];
				if (!this.$v.email.$dirty) {
					return errors;
				}
				if (!this.$v.email.required) {
					errors.push(this.$('email_overlay_error_required'));
				}
				if (!this.$v.email.email) {
					errors.push(this.$('email_overlay_error_required'));
				}
				return errors;
			},
			isMondiaUser() {
				return this.$store.getters.getSubscriptionsStoreId('mondia')
			},
			isOrangeFrUser() {
				return this.$store.getters.getSubscriptionsStoreId('orange')
			},
		},
		methods: {
			toggleModalDisplay() {
				this.$emit('toggleModalDisplay', false);
			},
			onSubmit() {
				this.isSubmitted = true;
				this.isLoading = true;
				this.$v.$touch();

				if (this.$v.$invalid) {
					this.isSubmitted = false;
					this.isLoading = false;
					return false;
				}

				AuthService.changeProfileInfo('email', this.email)
					.then(() => {
						if(this.isMondiaUser) {
							this.changePasswordPartnersMethod()
						}
						this.$store.dispatch('checkUserSubscriptions');
						this.toggleModalDisplay(false);
					})
					.catch((error) => {
						this.handleErrors(error.response);
						this.isSubmitted = false;
						this.isLoading = false;
					});
			},
			changePasswordPartnersMethod: function() {
				AuthService.changePasswordPartners(this.email)
					.then((response) => {
						if (response.status == 200) {
							this.$parent.showFlashMessage(this.$t('forgotten_password_sucess'));
						}
					}).catch((error) => {
						this.isSubmitted = false;
						this.isLoading = false;
					});
			},
			handleErrors: function(response) {
				return this.$parent.showFlashMessage(this.$t(getErrorString(response.status, response?.data?.code)));
			}
		},
	}
</script>

<style lang="scss" scoped>
	$regular-font: 'Nunito-Regular', Arial, sans-serif;

	.overlay-form {
		display: flex;
		flex-direction: column;
		gap: 15px;
		align-items: center;
		justify-content: center;
		text-align: center;
	}
	.overlay-wrap {
		position: fixed;
		z-index: 1000;
		display: flex;
		width: 100vw;
		height: 100vh;
		align-items: center;
		justify-content: center;
		padding: 10px;
		background: rgba(0,0,0,0.4);
	}

	.overlay {
		border-radius: 15px;
		box-shadow: 0px 0px 0px 4px rgba(255,255,255,1);
		text-align: center;
		background-color: white;
	}

	// .form-item__error {
	// 	margin-bottom: 24px;

	// 	span {
	// 		font-family: $regular-font;
	// 		font-size: 18px;
	// 		color: #ff5722;
	// 		text-shadow: 1px 0 0 rgba(0, 0, 0, 0.2);
	// 	}
	// }

	@keyframes pulse_button {
		0% {
			transform: scale(0.95);
			box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
		}

		70% {
			transform: scale(1);
			box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
		}

		100% {
			transform: scale(0.95);
			box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
		}
	}
.form-row {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  padding: 10px;
}

.box-title {
  flex: 1;
  text-align: center;
  font-size: 20px;
}

.close-btn {
  position: absolute;
  right: 10px;
  cursor: pointer;
  width: 20px;
  height: 20px;
  filter: invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(0%) contrast(119%);
}
.box-subtitle {
	text-align: center;
}
.form-box {
	border-radius: 20px;
}
.form {
	padding-bottom: 10px;
}
@media (orientation: portrait) {
    .box.form-box .form {
        width: 80%;
    }
}
</style>